<mat-accordion>
	<mat-expansion-panel [(expanded)]="expandStatus">
		<mat-expansion-panel-header>
			<mat-panel-title>
				{{ title }}
			</mat-panel-title>
		</mat-expansion-panel-header>
		<ng-content></ng-content>
	</mat-expansion-panel>
</mat-accordion>
